import type {
  RetrieveVimeoEventsResponse,
  ListWorkshopsResponse,
  CreateWorkshopResponse,
  CreateWorkshopBody,
  UpdateWorkshopResponse,
  UpdateWorkshopBody,
  DeleteWorkshopResponse,
  ListWorkshopsQuery,
  ToggleWorkshopCompletedResponse,
} from '$shared/api';
import { BaseService } from './utils/BaseService';

export class WorkshopService extends BaseService {
  async getVimeoEvents(): Promise<RetrieveVimeoEventsResponse> {
    return this.client.send('/api/workshops/events', {
      method: 'GET',
    });
  }

  async listWorkshops(
    query?: ListWorkshopsQuery,
  ): Promise<ListWorkshopsResponse> {
    return this.client.send('/api/workshops', {
      method: 'GET',
      query,
    });
  }

  async createWorkshop(
    body: CreateWorkshopBody,
  ): Promise<CreateWorkshopResponse> {
    return this.client.send('/api/workshops', {
      method: 'POST',
      body,
    });
  }

  async updateWorkshop(
    id: number,
    body: UpdateWorkshopBody,
  ): Promise<UpdateWorkshopResponse> {
    return this.client.send(`/api/workshops/${id}`, {
      method: 'PUT',
      body,
    });
  }

  async deleteWorkshop(id: number): Promise<DeleteWorkshopResponse> {
    return this.client.send(`/api/workshops/${id}`, {
      method: 'DELETE',
    });
  }

  async toggleWorkshopCompleted(
    id: number,
  ): Promise<ToggleWorkshopCompletedResponse> {
    return this.client.send(`/api/workshops/${id}/toggle-completed`, {
      method: 'PUT',
    });
  }
}
